
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.266","height":"21.266"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.75 .75)","stroke":"#d3d2d0","stroke-linecap":"round","stroke-linejoin":"round","fill":"none","data-name":"about us"}},[_c('circle',{attrs:{"data-name":"Ellipse 30","cx":"9.883","cy":"9.883","r":"9.883","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Line 132","stroke-width":"2","d":"M9.883 13.836V9.883"}}),_c('path',{attrs:{"data-name":"Line 133","stroke-width":"2","d":"M9.883 5.93h0"}})])])
          )
        }
      }
    